import { render } from "./AppFile.vue?vue&type=template&id=045cb847&scoped=true"
import script from "./AppFile.vue?vue&type=script&lang=js"
export * from "./AppFile.vue?vue&type=script&lang=js"

import "@/Common/Styles/appFile.scss?vue&type=style&index=0&id=045cb847&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045cb847"]])

export default __exports__